import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import { useOnClickOutside } from 'hooks';

import './Drawer.css';

const Drawer = ({
    anchor,
    backdrop,
    elevation,
    open,
    onClose,
    onOpen,
    children,
    className = '',
    height,
    width,
    top,
    left,
    right,
    widgetVariant = '',
}) => {
    const nodeRef = useRef(null);

    useOnClickOutside(nodeRef, onClose);

    height = typeof height === 'string' ? height : height + 'px';
    top = typeof top === 'string' ? top : top + 'px';
    width = typeof width === 'string' ? width : width + 'px';
    left = typeof left === 'string' ? left : left + 'px';
    right = typeof right === 'string' ? right : right + 'px';

    return (
        <CSSTransition
            nodeRef={nodeRef}
            in={open}
            timeout={300}
            classNames={`ab-drawer--${anchor}`}
            unmountOnExit
        >
            <div
                className={`ab-drawer-container ${
                    backdrop === true && open ? 'ab-drawer--backdrop' : ''
                }`}
                style={{
                    zIndex: elevation,
                }}
            >
                <div
                    className={`ab-drawer ab-drawer--${anchor} ${className} ${
                        widgetVariant === 'openBigDrawer' ? 'ab-no-shadow' : ''
                    }`}
                    ref={nodeRef}
                    style={{
                        height: height,
                        width: width,
                        top: top,
                        left: left,
                        right: right,
                        zIndex: elevation,
                    }}
                >
                    {children}
                </div>
            </div>
        </CSSTransition>
    );
};

Drawer.propTypes = {
    anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top', 'middle']),
    backdrop: PropTypes.bool,
    elevation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    widgetVariant: PropTypes.string,
};

export default Drawer;
